import React, { Component } from "react";
import { IFrame } from './iframe'
import { toAbsoluteUrl } from "../../../../_metronic/_helpers/AssetsHelpers";
import LeaderBoardFrame from "./index";
// import './assets/css/web-font.css'
// import './assets/css/style.css'

const LeaderIframe = (porps) => (
    <IFrame>
        <link rel="stylesheet" href={toAbsoluteUrl("/css/leaderboard/css/style.css")} />
        <link rel="stylesheet" href={toAbsoluteUrl("/css/leaderboard/css/web-font.css")} />
        <LeaderBoardFrame {...porps} />
    </IFrame>
)
export default LeaderIframe;